<template>
  <div class="service-city">
    <div class="city-sel-ipt" @click="switchVisible">
      <div class="city-sel-ipt-txt">{{ curCityName }}</div>
      <div class="city-sel-ipt-icon" :class="{ up: visible }"></div>
    </div>
    <div class="city-sel-mask" @click="switchVisible" v-show="visible"></div>

    <transition name="fade">
      <div v-show="visible">
        <div class="city-sel-cont">
          <div class="city-sel-cont-head">
            <ul class="tab-list">
              <li
                class="tab-item"
                @click="tabChange(idx, item)"
                :class="{ active: curIdx === idx }"
                v-for="(item, idx) in letters"
                :key="idx"
              >
                {{ item.value }}
              </li>
            </ul>
            <div class="close-icon" @click="switchVisible"></div>
          </div>
          <div class="city-sel-cont-body">
            <div
              v-for="(item, idx) in selList"
              :key="idx"
              class="city-list-box"
            >
              <div class="city-letter">{{ item.letter }}</div>
              <ul class="city-name-list">
                <li
                  class="city-name-item"
                  v-for="(city, cidx) in item.cityList"
                  @click="cityChange(city)"
                  :key="cidx"
                >
                  {{ city.authorizeCity }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="city-sel-cont-pic">
          <div class="city-sel-cont-head-pic-box">
            <div class="city-sel-cont-head-pic">
              <span>{{ selTitel }}</span>
              <span class="close-icon" @click="switchVisible"></span>
            </div>
          </div>
          <div class="city-sel-cont-body-pic-box">
            <div class="pic-letter-bg">{{ curLetter }}</div>
            <div class="city-sel-cont-body-pic" id="cityScollBox">
              <div id="letterBox">
                <div
                  v-for="(item, idx) in list"
                  :key="idx"
                  class="city-list-box"
                >
                  <div class="city-letter">
                    {{ item.letter === "#" ? "" : item.letter }}
                  </div>
                  <ul class="city-name-list">
                    <li
                      class="city-name-item"
                      v-for="(city, cidx) in item.cityList"
                      @click="cityChange(city)"
                      :key="cidx"
                    >
                      {{ city.authorizeCity }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    this.$letterPosetions = [];
    // this.$letterBoxHeight = 0;
    // this.$scollBoxHeight = 0;
    return {
      letters: [
        { letter: "#", value: "全国" },
        { letter: "ABCDE", value: "ABCDE" },
        { letter: "FGHJ", value: "FGHJ" },
        { letter: "KLMNP", value: "KLMNP" },
        { letter: "QRSTW", value: "QRSTW" },
        { letter: "XYZ", value: "XYZ" },
      ],
      curIdx: 1,
      visible: false,
      curCityName: "全国",
      curLetter: "#",
    };
  },
  props: {
    selTitel: String,
    list: Array,
  },
  computed: {
    selList({ curIdx, list, letters }) {
      const letterStr = letters[curIdx].letter;
      const newList = list.filter((item) => {
        return letterStr.indexOf(item.letter) > -1;
      });
      return newList;
    },
  },
  watch: {
    visible(val) {
      let el = document.scrollingElement || document.documentElement;
      if (val) {
        el.style.cssText = "overflow:hidden;";
        if (this.curIdx === 0) {
          this.tabChange(1);
        }
        this.$nextTick(() => {
          this.getLetters();
        });
      } else {
        el.style.cssText = "";
      }
    },
  },
  methods: {
    getLetters() {
      if (this.$letterPosetions.length) return;

      const $letters = document.querySelectorAll("#letterBox .city-letter");
      // 获取所有字母距离顶端的高度
      this.$letterPosetions = Array.from($letters).map((item, idx) => {
        let nextItem = $letters[idx + 1] || {};
        return {
          letter: this.list[idx].letter,
          offsetTop: item.offsetTop,
          min: item.offsetTop,
          max: nextItem.offsetTop || item.offsetTop + 60,
        };
      });

      // 获取父级元素的高度
      // const $letterBox = document.getElementById("letterBox");
      // this.$letterBoxHeight = $letterBox.offsetHeight;

      // 获取滚动区域的宽度
      // const $scollBox = document.getElementById("cityScollBox");
      // this.$scollBoxHeight = $scollBox.offsetHeight;
    },
    cityChange(city) {
      this.curCityName = city.authorizeCity;
      this.switchVisible();
      this.$emit("onSelctCity", city);
    },
    tabChange(idx, item = {}) {
      // 选中了全国
      if (item.letter === "#") {
        this.$nextTick(() => {
          const cityList = this.selList[0].cityList;
          const city = cityList[0];
          this.cityChange(city);
        });
      }
      // 如果相同就不重新复制和查找数据了
      if (this.curIdx === idx) return;
      this.curIdx = idx;
    },
    switchVisible() {
      this.visible = !this.visible;
    },
    getCurLetter(scrollTop) {
      let curItem = this.$letterPosetions.find((item) => {
        const { min, max } = item;
        if (scrollTop >= min && scrollTop < max) {
          return item;
        }
      });
      this.curLetter = curItem?.letter || "#";
    },
  },
  mounted() {
    const $cityScollBox = document.getElementById("cityScollBox");

    $cityScollBox.addEventListener("scroll", (e) => {
      if (this.timer) return;
      this.timer = setTimeout(() => {
        this.timer = null;
        this.getCurLetter(e.target.scrollTop);
      }, 200);
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@style/base";
@import "@style/base/mixins/scrollBar";
.service-city {
  position: relative;
  z-index: 2;
}
.city-sel-ipt {
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  width: 327px;
  height: 54px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #eeeeee;
  padding: 0 14px 0 16px;
  font-size: 14px;

  @include media(
    (
      $md: (
        width: 252px,
        height: 42px,
      ),
      $sm: (
        justify-content: center,
        width: auto,
        height: 30px,
        padding: 0 4px 0 0px,
        border: none,
        background: none,
      ),
    )
  );
  .city-sel-ipt-icon {
    margin-left: 5px;
    height: 20px;
    width: 20px;
    background-position: center;
    background-size: cover;
    background-image: url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210611114753218-icon_common_arrows_24_dow_gray@3x.png);
    transition: transform 200ms $easeOutCubic;
    transform: rotate(0deg);
    &.up {
      transform: rotate(180deg);
    }
  }
}
.city-sel-cont {
  background: #fff;
  width: 590px;
  box-shadow: $boxShadow;
  position: absolute;
  right: 0;
  top: 64px;
  @include media(
    (
      $md: (
        display: none,
      ),
    )
  );
}
.city-sel-cont-head {
  position: relative;
  border-bottom: 3px solid #f6f7f8;
  .tab-list {
    display: flex;
    align-items: center;
    .tab-item {
      cursor: pointer;
      width: 90px;
      text-align: center;
      line-height: 22px;
      padding: 12px 0;
      color: #747a86;
      font-size: 14px;
      position: relative;
      &::after {
        content: " ";
        position: absolute;
        bottom: -3px;
        width: 100%;
        left: 0;
        height: 3px;
        transform: scale(0);
        background: #131415;
      }
      &.active::after {
        transform: scale(1);
        transition: transform 400ms $easeOutCubic;
      }
    }
  }
}
.city-sel-cont-body {
  padding: 10px 0;
  .city-list-box {
    display: flex;
    line-height: 40px;
    .city-letter {
      width: 76px;
      text-align: center;
      color: #747a86;
      flex-shrink: 0;
    }
    .city-name-list {
      display: flex;
      flex-grow: 1;
      flex-wrap: wrap;
      .city-name-item {
        cursor: pointer;
        flex-grow: 0;
        width: 25%;
        padding-right: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: keep-all;
      }
    }
  }
}
.city-sel-cont-pic {
  width: 100%;
  box-shadow: $boxShadow;
  position: absolute;
  right: 0;
  top: 52px;
  display: none;
  @include media(
    (
      $md: (
        display: block,
      ),
      $sm: (
        box-shadow: none,
        position: fixed,
        left: 0,
        top: auto,
        bottom: 0,
      ),
    )
  );
}
.city-sel-cont-head-pic-box {
  display: none;
  @include media(
    (
      $sm: (
        display: block,
      ),
    )
  );
}
.city-sel-cont-head-pic {
  height: 60px;
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  align-items: center;
  position: relative;
  font-size: 18px;
  font-weight: bold;
  background: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
}
.city-sel-cont-body-pic-box {
  position: relative;
  .pic-letter-bg {
    line-height: 30px;
    height: 30px;
    padding-left: 30px;
    background: #f6f7f8;
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
  }
}
.city-sel-cont-body-pic {
  background: #f6f7f8;
  max-height: 530px;
  overflow-y: scroll;
  .city-letter {
    line-height: 30px;
    height: 30px;
    background: #f6f7f8;
    padding-left: 30px;
    // position: sticky;
    top: 0;
    // z-index: 1;
  }
  .city-name-list {
    background: #fff;
    padding-left: 30px;
    .city-name-item {
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: keep-all;
      height: 60px;
      line-height: 60px;
      & + .city-name-item {
        border-top: 1px solid #eee;
      }
    }
  }
}
.city-sel-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  @include media(
    (
      $sm: (
        background: rgba(24, 26, 36, 0.6),
      ),
    )
  );
}
.close-icon {
  cursor: pointer;
  position: absolute;
  height: 30px;
  width: 30px;
  top: 50%;
  right: 5px;
  transform: translateY(-50%);
  background-size: cover;
  background-position: center;
  background-image: url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20210611133718303-icon_close%403x.png);
}
// 动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 200ms $easeOutCubic;
}
.fade-enter,
.fade-enter-from,
.fade-leave-to {
  opacity: 0 !important;
}
</style>
